import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DescriptionComponent } from './description.component';
import { RatingModule } from '../../../component/rating/rating.module';
import { LanguageService } from 'libraries/service/language/language.service';
import { IsNullOrEqualsPipeModule } from "libraries/pipes/is-null-or-equals/is-null-or-equals.module";
import { SafeHtmlPipeModule } from "libraries/pipes/safeHtml/safeHtml.module";
import { HtmlizePipeModule } from 'libraries/pipes/htmlize/htmlize.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import { DescriptionHelperModule } from "libraries/service/description-helper/description-helper.module";

@NgModule({
    imports: [
        CommonModule,
        RatingModule,
        IsNullOrEqualsPipeModule,
        SafeHtmlPipeModule,
        HtmlizePipeModule,
        FontAwesomeModule,
        DescriptionHelperModule,
    ],
    exports: [
        DescriptionComponent,
    ],
    declarations: [
        DescriptionComponent,
    ],
    providers: [
        LanguageService,
    ],
})
export class DescriptionModule { }
